import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Group } from '@mantine/core';

export const HeaderWrapper = styled.header`
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const HeaderContent = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0 24px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 0 48px;
  }

  @media (min-width: 1200px) {
    padding: 0 64px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
`;

export const LogoLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
`;

export const LogoInternalLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  height: 40px;
  width: auto;

  @media (min-width: 768px) {
    height: 50px;
  }
`;

export const DesktopNav = styled.nav`
  display: none;
  gap: 24px;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const NavLinkStyled = styled.a`
  color: #495057;
  font-weight: 500;
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #4d18c4;
  }

  &:focus-visible {
    outline: 2px solid #4d18c4;
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const InternalNavLink = styled(Link)`
  color: #495057;
  font-weight: 500;
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #4d18c4;
  }

  &:focus-visible {
    outline: 2px solid #4d18c4;
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const ButtonGroup = styled(Group)`
  display: none;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const MobileBurger = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0;
  margin-top: 16px;
  border-top: 1px solid #e9ecef;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileNavLink = styled.a`
  color: #495057;
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  padding: 8px 0;
  transition: color 0.2s ease;

  &:hover {
    color: #4d18c4;
  }

  &:focus-visible {
    outline: 2px solid #4d18c4;
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const MobileInternalNavLink = styled(Link)`
  color: #495057;
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  padding: 8px 0;
  transition: color 0.2s ease;

  &:hover {
    color: #4d18c4;
  }

  &:focus-visible {
    outline: 2px solid #4d18c4;
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const MobileButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;
